<div class="container" [style.padding]="padding">
  <project-view-icon-container [icon]="icon"></project-view-icon-container>

  <div class="content">
    <ng-content></ng-content>
  </div>
</div>
